import { connect } from "react-redux";
import { FlokkarProduct } from ".";
import { getAllVoruMerki } from "../../../reducers/selectors";

function fetchAllTest() {
  console.log("test");
}

interface IStateProps {
  content: any;
}
interface IDispatchProps {
  fetchAllTest: () => void;
}
interface IProps {
  location: string;
}
export default connect<IStateProps, IDispatchProps, IProps>(
  (state: any) => ({
    content: getAllVoruMerki(state)
  }),
  {
    fetchAllTest
  }
)(FlokkarProduct);



// WEBPACK FOOTER //
// ./src/components/Product-page/flokkar-product/flokkar-product.conn.tsx